
(function ($) {

  function ready() {
    $('.stretcher').hide();

    $('.display').click(function () {
      $(this).next().slideToggle();
      return false;
    }).next().hide();
  }

  $(document).ready(ready);

}(jQuery));
